import { deleteBuild } from "@dashboard/products/store";
import { ListenerMiddlewareInstance, UnsubscribeListener } from "@reduxjs/toolkit";

import { rolloutsApi } from ".";

export const initOtaFilesCacheListener = (listenerMiddleware: ListenerMiddlewareInstance): UnsubscribeListener => {
    return listenerMiddleware.startListening({
        actionCreator: deleteBuild.fulfilled,
        effect: (_action, listenerApi) => {
            listenerApi.dispatch(rolloutsApi.util.invalidateTags(["OtaFiles"]));
        },
    });
};
